export default {
  hero_title: "Atteignez facilement la conformité carbone CBAM de l'UE",
  hero_subtitle:
    "Une plateforme de calcul carbone conçue pour les PME, basée sur des facteurs officiels/personnalisés de l'UE, pour générer rapidement des rapports conformes.",
  what_is_taxecobit: "Qu'est-ce que TaxEcoBit ?",
  taxecobit_description:
    "TaxEcoBit est une plateforme d'automatisation de la conformité conçue pour les entreprises affectées par le Mécanisme d'Ajustement des Frontières Carbone (CBAM) de l'UE. Nous aidons les importateurs, les fabricants et les PME à calculer les émissions de carbone au niveau des produits, à générer des rapports conformes au CBAM et à réduire les risques réglementaires.",
  taxecobit_benefits: "Avec TaxEcoBit, les utilisateurs peuvent :",
  benefit_accurate_calculations:
    "Effectuer des calculs carbone précis en utilisant des facteurs d'émission officiels et personnalisés",
  benefit_cbam_documents: "Générer des documents CBAM prêts à être soumis",
  benefit_carbon_cost_tracking:
    "Surveiller l'impact des coûts carbone et optimiser l'efficacité opérationnelle",
  benefit_api_integration:
    "Intégrer de manière transparente les flux de travail de conformité via l'API avec les systèmes ERP et de chaîne d'approvisionnement",
  taxecobit_conclusion:
    "En remplaçant les feuilles de calcul manuelles et la dépendance aux consultants, TaxEcoBit permet une conformité plus rapide et plus fiable à un coût opérationnel inférieur.",
  register_now: "S'inscrire maintenant",
  experience_calculator: "Essayer le calculateur CBAM",
  try_cbam_calculator: "Utiliser le calculateur CBAM",
  try_cbam_quick_check: "Essayer le test rapide CBAM",
  download_sample_report: "Télécharger un exemple de rapport",
  pdf_report: "Rapport PDF",
  excel_report: "Rapport Excel",
  precise: "Précis",
  how_it_works: "Comment ça marche",
  precise_description:
    "Basé sur des facteurs officiels/personnalisés de l'UE, avec une erreur de calcul < 5 %, répondant aux exigences de conformité.",
  efficient: "Efficace",
  efficient_description:
    "Prend en charge les calculs groupés, génère automatiquement des rapports PDF/Excel avec une configuration flexible.",
  sme_focused: "Axé sur les PME",
  sme_focused_description:
    "Aucun bagage professionnel requis, interface conviviale pour une adoption rapide.",
  api_support: "Prise en charge de l'API",
  api_support_description:
    "Intégrez facilement les systèmes ERP/e-commerce pour un reporting de conformité automatisé.",
};
